export default __webpack_public_path__ + "assets/images/537bd97427087b2e76def5931afba436.png";